// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image_wrapper__47189","image":"image_image__MAcrC"};